import { Injectable } from '@angular/core';
import { AbstractControl, FormGroup } from '@angular/forms';
import * as moment from 'moment';
import { MomentInput, MomentInputObject } from 'moment';
import { IRange } from '../model/IRange';
import 'moment-timezone';
import { MilestoneStatus } from '../model/MilestoneStatus';

@Injectable({
  providedIn: 'root'
})
export class UtilsService {

  static minArrayLength(min: number) {
    return (control: AbstractControl): {[key: string]: boolean} | null => {

      if ( control.value !== null && control.value.length < min){
        return { minArrayLengthValidator: true};
      }
      return null;
    };
  }

  static passwordsMatched() {
    return (form: FormGroup): {[key: string]: boolean} | null => {
      const newPassword = form.get('newPassword');
      const newPasswordAgain = form.get('newPasswordAgain');
      if (newPassword.value !== newPasswordAgain.value) {
        return {
          passwordsMatched: false
        }
      }
      return null;
    };
  }

  public static getFirstCCY(instrument: string) {
    if (instrument.includes('/')) {
      return instrument.split('/')[0];
    }
    return instrument.substring(0, 3);
  }

  public static getSecondCCY(instrument: string) {
    if (instrument.includes('/')) {
      return instrument.split('/')[1];
    }
    return instrument.substring(3, 6);
  }

  public static createQueryDate(value: Date): string {
    return `${value.getMonth()}/${value.getDay()}/${value.getFullYear()}`;
  }

  public static parseDate(date: Date) {
    const NYDate = moment(date).tz('America/New_York').toDate();
    return `${NYDate.getMonth() + 1}/${NYDate.getDate()}/${NYDate.getFullYear()}`;
  }

  public static getNyDate(date: MomentInput = new Date()): Date {
    return moment(date).tz('America/New_York').toDate();
  }

  public static getNYDateTime(year: number, month: number, day: number, hours, minutes: number, seconds: number) {
    const obj: MomentInputObject = {
      year: year,
      month: month,
      day: day,
      hours: hours,
      minutes: minutes,
      seconds: seconds
    }
    return moment(obj).tz('America/New_York').toDate();
  }

  static isNotUndefinedOrNull(value: any) {
    return value !== undefined && value !== null;
  }

  static getValueOrEmptyString(value: any) {
    if (UtilsService.isNotUndefinedOrNull(value)) {
      return value;
    }
    return '';
  }

  static getMilestoneEnumFromTransferState(state: number, transferStatus: string): MilestoneStatus {
    switch (state) {
      case 0: return MilestoneStatus.PENDING;
      case 1: return MilestoneStatus.ACTIVE;
      case 2: {
        if (transferStatus === 'OK') {
          return MilestoneStatus.COMPLETED;
        } else {
          return MilestoneStatus.FAILED;
        }
      }
      case 3: return MilestoneStatus.ABORTED;
      case 4: return MilestoneStatus.SUSPENDED;
    }
    throw new Error('Invalid state');
  }

  public static getRanges(): IRange[] {
      return [
        {
          value: [UtilsService.getNyDate(UtilsService.getNyDate().setDate(UtilsService.getNyDate().getDate() - 1)), UtilsService.getNyDate()],
          label: 'Yesterday'
        }, {
          value: [UtilsService.getNyDate(UtilsService.getNyDate().setDate(UtilsService.getNyDate().getDate() - 7)), UtilsService.getNyDate()],
          label: 'Last 7 Days'
        }, {
          value: [UtilsService.getNyDate(UtilsService.getNyDate().setDate(UtilsService.getNyDate().getDate() - 30)), UtilsService.getNyDate()],
          label: 'Last 30 Days'
        }
      ];
    }

  public static isLastElementInArray(length: number, index: number) {
    return length === index + 1;
  }

  public static convertToDecimalNumber(num) {
    if (!num) {
      return Number(num);
    }
    const numStr = num.toString();
    if (numStr.indexOf('e') != -1) {
      const exponent = parseInt(numStr.split('-')[1], 10);
      return Number(num.toFixed(exponent));
    } else {
      return Number(num);
    }
  }
}
